<script>
    import  { Line }  from 'vue-chartjs';
    export default {
        extends: Line,
        props: [
            'data',
            'chartOptions',
            'options'
        ],
        data(){
            return {
                options_default: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 0,
                        }
                    },
                    legend: {
                        display: true,
                        labels: {
                            padding: 20,
                        },

                    },
                    tooltips: {
                        bodyFontSize: 18,
                        titleFontSize: 18,
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return Chart.defaults.global.tooltips.callbacks.label(tooltipItem, data) + '%';
                            },
                        },
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                // Include a dollar sign in the ticks
                                callback: function(value, index, values) {
                                    return  value + '%';
                                },
                                fontStyle: 'bold',
                                beginAtZero: true,
                                fontSize: 14,
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontSize: 14,
                                fontStyle: 'bold',
                                padding: 10,
                            },
                        }]
                    }
                }
            };
        },
        mounted () {
            var mergedObject = Object.assign({}, this.options_default, this.options);
            this.renderChart(this.data, mergedObject);
        },
    };
</script>